export const applicantInfo = {
  caption: "Сведения о заявителе",
  gridKey: "grid-container-applicant-info",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: false,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: false,
    },
    programId: {
      key: "programId",
      label: "Программа подготовки",
      type: "selectWithSearch",
      placeholder: "Выберите программу",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
    surname: {
      key: "surname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    name: {
      key: "name",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    midname: {
      key: "midname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    docType: {
      key: "docType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите документ",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
    serialOfPassport: {
      key: "serialOfPassport",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
      pattern: {
        value: /^[a-zA-Z]{2}$/,
        message: `Введите 2 латинские буквы`,
      },
    },
    numberOfPassport: {
      key: "numberOfPassport",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    docDateIssue: {
      key: "docDateIssue",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customValidation(value) {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
          return "Дата не может быть ранее 26.09.1996";
        } else {
          return true;
        }
      },
    },
    docDepartment: {
      key: "docDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    persNum: {
      key: "persNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      upperCase: true,
    },
    address: {
      key: "address",
      label: "Адрес",
      type: "text",
      placeholder:
        "Введите полностью страну, область или г. Минск, город или район и населенный пункт, улицу, номер дома, корпуса, квартиры",
      fieldModeView: false,
      textarea: "textarea",
      required: true,
      needInForm: true,
      disabled: false,
      upperCase: true,
    },
    birthDate: {
      key: "birthDate",
      label: "Дата рождения",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customButton: false,
      upperCase: true,
      customValidation(value) {
        const today = new Date();
        const birthDate = new Date(value);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          return "Заявитель должен быть старше 18 лет на дату подачи заявления";
        } else {
          return true;
        }
      },
    },
    phone: {
      key: "phone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Недопустимые символы: введите цифры, (), -, +`,
      },
    },
    birthPlace: {
      key: "birthPlace",
      label: "Место рождения",
      type: "selectWithSearch",
      placeholder: "Введите полное наименование страны",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      upperCase: true,
      textOrId: true,
      options: [],
    },
  },
};

export const medicalCertificate = {
  caption: "Медицинская справка",
  gridKey: "grid-container-medical-certificate",
  blockVisibility: true,
  inputsOptions: {
    documentMedicalDocNum: {
      key: "documentMedicalDocNum",
      label: "Номер",
      type: "number",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
    documentMedicalDocDate: {
      key: "documentMedicalDocDate",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customValidation(value) {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else {
          return true;
        }
      },
    },
    documentMedicalPeriod: {
      key: "documentMedicalPeriod",
      label: "Срок действия, лет",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [
        {
          value: 1,
          label: "1",
          key: "documentMedicalPeriod",
        },
        {
          value: 2,
          label: "2",
          key: "documentMedicalPeriod",
        },
        {
          value: 3,
          label: "3",
          key: "documentMedicalPeriod",
        },
        {
          value: 4,
          label: "4",
          key: "documentMedicalPeriod",
        },
        {
          value: 5,
          label: "5",
          key: "documentMedicalPeriod",
        },
      ],
    },
  },
};

export const trainingInformation = {
  caption: "Сведения об обучении",
  gridKey: "grid-container-training-information",
  blockVisibility: true,
  inputsOptions: {
    dateStart: {
      key: "dateStart",
      label: "Период обучения с",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation(value, data) {
        if (!value || !data) {
          return true;
        }
        if (data.dateEnd) {
          const periodEnd = new Date(data.dateEnd);
          const periodStart = new Date(value);
          if (periodEnd - periodStart < 24 * 60 * 60 * 1000) {
            return `"Период с" - минимум на 1 день раньше "Период по"`;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
    },
    dateEnd: {
      key: "dateEnd",
      label: "период обучения по",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation(value, data) {
        if (!value || !data) {
          return true;
        }
        if (data.dateStart) {
          const periodEnd = new Date(value);
          const periodStart = new Date(data.dateStart);
          if (periodEnd - periodStart < 24 * 60 * 60 * 1000) {
            return `"Период по" - минимум на 1 день позднее "Период с"`;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
    },
  },
};

export const contractInfo = {
  caption: "Сведения о заключении договора",
  gridKey: "grid-container-contract-info",
  blockVisibility: true,
  inputsOptions: {
    contractNum: {
      key: "contractNum",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    contractDate: {
      key: "contractDate",
      label: "Дата договора",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation(value) {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else {
          return true;
        }
      },
    },
  },
};

export const isNeedToPaySelector = {
  key: "isNeedToPaySelector",
  label: "Выставить счет на оплату",
  type: "selectWithSearch",
  placeholder: "Выберите",
  fieldModeView: false,
  disabled: false,
  isSearchable: false,
  required: true,
  needInForm: true,
  options: [
    {
      value: true,
      label: "Да",
      key: "isNeedToPaySelector",
    },
    {
      value: false,
      label: "Нет",
      key: "isNeedToPaySelector",
    },
  ],
};

export const optionsForPasswordModal = {
  caption: "Пароль ЭЦП",
  gridKey: "",
  blockVisibility: true,
  inputsOptions: {
    pw: {
      key: "pw",
      label: "Пароль",
      type: "password",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
  },
};

export const setOptionsTrainingProgram = (lib) => {
  const validLib = lib.map((el) => {
    return {
      ...el,
      value: el.id,
      label: el.sign,
      key: "programId",
    };
  });
  if (applicantInfo.inputsOptions.programId.options.length === 0) {
    applicantInfo.inputsOptions.programId.options.push(...validLib);
  }
  return applicantInfo;
};

export const setOptionsDocType = (lib) => {
  const validLib = lib.map((el) => {
    return { ...el, key: "docType" };
  });
  if (applicantInfo.inputsOptions.docType.options.length === 0) {
    applicantInfo.inputsOptions.docType.options.push(...validLib);
  }
  return applicantInfo;
};

export const setBirthPlaceOptions = (lib) => {
  const validLib = lib.map((el) => {
    return { ...el, key: "birthPlace", label: el.countryFullname };
  });
  if (applicantInfo.inputsOptions.birthPlace.options.length === 0) {
    applicantInfo.inputsOptions.birthPlace.options.push(...validLib);
  }
  return applicantInfo;
};

export const setBirthPlaceOptionsByData = (data) => {
  if (data) {
    applicantInfo.inputsOptions.birthPlace.type = "text";
  } else {
    applicantInfo.inputsOptions.birthPlace.type = "selectWithSearch";
  }
  return applicantInfo;
};

export function setMidnameRequiredByDocType(docType) {
  if (docType === 1 || docType === 4) {
    applicantInfo.inputsOptions.midname.required = true;
  } else {
    applicantInfo.inputsOptions.midname.required = false;
  }
  return applicantInfo;
}

export const setOptionsByMode = (mode) => {
  if (mode === "add" || mode === "edit") {
    applicantInfo.gridKey =
      mode === "edit" ? "grid-container-applicant-info-view" : "grid-container-applicant-info";
    medicalCertificate.gridKey = "grid-container-medical-certificate";
    trainingInformation.gridKey = "grid-container-training-information";
    contractInfo.gridKey = "grid-container-contract-info";
  } else {
    applicantInfo.gridKey = "grid-container-applicant-info-view";
    medicalCertificate.gridKey = "grid-container-medical-certificate-view";
    trainingInformation.gridKey = "grid-container-training-information-view";
    contractInfo.gridKey = "grid-container-contract-info-view";
  }
  return {
    applicantInfo: applicantInfo,
    medicalCertificate: medicalCertificate,
    trainingInformation: trainingInformation,
    contractInfo: contractInfo,
  };
};
